export class Rating {
    customerId: number;
    productItemRequestId: number;
    rating: number;
}